import { Http, PageData, PageQuery } from '@mygpt/app/http';

export interface GetDictionaryParams extends PageQuery {
  aiId: string;
  search?: string;
  start_date?: string;
  end_date?: string;
}

export interface DictionaryItem {
  id: string;
  created_at: string;
  updated_at: string;
  source: string;
  target: string;
}

/**
 * 获取字典列表
 * @param params
 * @returns
 */
export const getDictionaryService = (params: GetDictionaryParams) => {
  const { get } = Http.use();
  return get<PageData<DictionaryItem>>(`/robots/${params.aiId}/dictionaries`, { params });
};
